//illustration
export {default as getStartedIllustration} from 'url:./illustrations/get-started-illustration.png';

//app store buttons
export {default as googlePlay} from 'url:./images/googleplaybutton.png';
export {default as appStore} from 'url:./images/appstorebutton.png';

//videos
export { default as getStartedVideo } from 'url:./videos/get-started.mp4';